<template>
  <div class="d-flex flex-wrap w-100 max-w-xl mx-auto">
    <div class="w-100 item-outer col p-3">
      <div class="border h-100 flex flex-col justify-between align-items-center rounded item_border item_border_arrow relative border_main11">
        <div class="p-2 w-100 bg-blue-lighter-toeic flex align-items-center justify-between">
          <p class="font-bold text-white text-center text-lg mb-0">輸入測試</p>
          <p class="font-bold text-white md:text-lg text-center mb-0">已輸入 {{ textLength }} 個單字</p>
        </div>
        <div class="p-3 px-3 mb-1 pointer w-100">
          <textarea v-model="inputVal" name="TestingTools" id="" rows="5" class="border rounded w-100 p-2 border_main13" placeholder="點此輸入......"></textarea>
        </div>

        <div class="p-3">
          <p class="gept_main_color text-center fw-semibold mb-0 text-base">請在框內輸入英文，確認設備與輸入法有正常運作。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestingToolsWriting',
  props: {
  },
  data () {
    return {
      inputVal: null
    }
  },
  computed: {
    textLength () {
      if (this.inputVal) {
        let words = this.inputVal.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "").split(" ")
        let wordCount = words.filter(word => word.length > 0).length
        return wordCount
      }
      return 0
    }
  },
  watch: {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
</style>
